<aa-dash-card [footer]="false">
    <div dash-card-header>
        <aa-label-qty [colorLabel]="'dark'" [colorCounter]="'primary-normal'"
                      [label]="'DASH.ITSM.CREATION.CASE.TITLE' | translate">
        </aa-label-qty>
    </div>
    <div dash-card-body>
        <aa-btn-action-secondary [btnText]="'DASH.ITSM.CREATION.CASE.BUTTON' | translate" (click)="createIncident()">
        </aa-btn-action-secondary>
    </div>
</aa-dash-card>
